module.exports = __webpack_public_path__ + "img/3.adb47088.png";